import { useEffect, useRef } from 'react';
import { useAuth } from 'react-oidc-context';

/**
 * Componente che gestisce il silent sign-in automatico per SSO cross-domain
 * Quando l'utente arriva da un altro dominio (es. assobay.staging.it) già loggato,
 * tenta automaticamente il silent sign-in per riconoscere la sessione attiva
 */
export default function AuthSilentSignIn() {
    const auth = useAuth();
    const hasAttemptedSilentSignIn = useRef(false);

    useEffect(() => {
        // Aspetta che auth sia completamente inizializzato
        if (auth.isLoading) {
            return;
        }

        // Se l'utente è già autenticato, non fare nulla
        if (auth.isAuthenticated) {
            return;
        }

        // Se c'è già un navigator attivo (login in corso), non fare nulla
        if (auth.activeNavigator) {
            return;
        }

        // Se abbiamo già tentato il silent sign-in, non ripetere
        if (hasAttemptedSilentSignIn.current) {
            return;
        }

        // Prova a fare un silent sign-in se c'è già una sessione attiva su Identity Server
        hasAttemptedSilentSignIn.current = true;

        console.log("Tentativo di silent sign-in per SSO cross-domain...");
        
        auth.signinSilent()
            .then((user) => {
                console.log("Silent sign-in riuscito!", user);
                // Il token verrà gestito automaticamente da UserProvider
            })
            .catch((error) => {
                // Silent sign-in fallito - nessuna sessione attiva o errore
                hasAttemptedSilentSignIn.current = false; // Reset per permettere un nuovo tentativo
                console.log("Silent sign-in non disponibile:", error.message || error);
            });
    }, [auth.isLoading, auth.isAuthenticated, auth.activeNavigator, auth.signinSilent]);

    // Questo componente non renderizza nulla
    return null;
}

